import React from "react";
import "./CustomQuestionForm.scss";
import CustomQuestion from "../CustomQuestion/CustomQuestion";
import { QuestionSchema } from "../../models/QuestionForm";
import { VENDOR_FORM_INPUT_TYPES } from "../../data/VendorForm.data";

interface CustomQuestionFormProps {
  allQuestions: QuestionSchema[];
  handleAddNewQuestion: (inputType: string) => void;
  handleDeleteQuestion: (questionId: number) => void;
  handleQuestionValueChanges: (
    id: number,
    questionValues: QuestionSchema
  ) => void;
  backGround?: string;
  formTitle?: string;
  setFormTitle: (title: string) => void;
  formDescription?: string;
  setFormDescription: (description: string) => void;
  vendorForm?: boolean;
}

const CustomQuestionForm: React.FC<CustomQuestionFormProps> = ({
  allQuestions,
  handleAddNewQuestion,
  handleDeleteQuestion,
  handleQuestionValueChanges,
  backGround,
  vendorForm,
  formTitle,
  setFormTitle,
  formDescription,
  setFormDescription,
}) => {
  return (
    <div
      style={{ background: backGround }}
      className="custom-question-forms-details-main-container px-16 py-32 flex-1 overflow-scroll border-box"
    >
      <div className="middle-main-container-form-detail-container flex-row align-items-center">
        <div className="question-types-main-container flex-row gap-12 p-12 border-box">
          <div className="four-boxes-container flex-column gap-12">
            <div
              onClick={() => handleAddNewQuestion(VENDOR_FORM_INPUT_TYPES.TEXT)}
              className="form-input-type-container xetgo-font-tag flex-column gap-8 align-items-center p-15 py-17 cursor-pointer border-box"
            >
              <p className="text-icon">T</p>
              <p className="bold">Text</p>
            </div>
            <div
              onClick={() =>
                handleAddNewQuestion(VENDOR_FORM_INPUT_TYPES.RADIO)
              }
              className="form-input-type-container xetgo-font-tag flex-column gap-8 align-items-center p-12 py-19 cursor-pointer border-box"
            >
              <input
                type="radio"
                className="radio-btn-form-input-type"
                checked
              />
              <p className=" bold">Radio Button</p>
            </div>
            <div
              onClick={() =>
                handleAddNewQuestion(VENDOR_FORM_INPUT_TYPES.CHECKBOX)
              }
              className="form-input-type-container xetgo-font-tag flex-column gap-8 align-items-center p-12 py-19 cursor-pointer border-box"
            >
              <input
                type="checkbox"
                className="checkbox-btn-form-input-type"
                checked
              />
              <p className="bold">CheckBox</p>
            </div>
            <div
              onClick={() =>
                handleAddNewQuestion(VENDOR_FORM_INPUT_TYPES.PARAGPAPH)
              }
              className="form-input-type-container xetgo-font-tag flex-column gap-8 align-items-center p-12 py-19 cursor-pointer border-box"
            >
              <img
                height={22}
                width={22}
                src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250303122003-text.svg"
                alt="text-icon"
              />

              <p className=" bold">Paragraph</p>
            </div>
          </div>
          <div className="four-boxes-container flex-column gap-12">
            <div
              onClick={() =>
                handleAddNewQuestion(VENDOR_FORM_INPUT_TYPES.NUMBER)
              }
              className="form-input-type-container xetgo-font-tag flex-column gap-8 align-items-center p-12 py-19 cursor-pointer border-box"
            >
              <img
                height={16}
                width={14}
                src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250303122132-%23.svg"
                alt="text-icon"
              />

              <p className="bold">Number</p>
            </div>
            <div
              onClick={() => handleAddNewQuestion(VENDOR_FORM_INPUT_TYPES.DATE)}
              className="form-input-type-container xetgo-font-tag flex-column gap-8 align-items-center p-12 py-19 cursor-pointer border-box"
            >
              <img
                height={16}
                width={14}
                src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250228064659-calendar-days.svg"
                alt="text-icon"
              />

              <p className="bold">Date & Time</p>
            </div>
            <div
              onClick={() =>
                handleAddNewQuestion(VENDOR_FORM_INPUT_TYPES.MULTI_FILE_UPLOAD)
              }
              className="form-input-type-container xetgo-font-tag flex-column gap-8 align-items-center p-12 py-19 cursor-pointer border-box"
            >
              <img
                height={16}
                width={14}
                src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240510114359-upload.svg"
                alt="text-icon"
              />

              <p className="bold">Multi Upload</p>
            </div>
            <div
              onClick={() =>
                handleAddNewQuestion(VENDOR_FORM_INPUT_TYPES.FILE_UPLOAD)
              }
              className="form-input-type-container xetgo-font-tag flex-column gap-8 align-items-center p-12 py-19 cursor-pointer border-box"
            >
              <img
                height={16}
                width={14}
                src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240510114359-upload.svg"
                alt="text-icon"
              />

              <p className="bold"> Upload</p>
            </div>
          </div>
        </div>

        <div className="all-question-main-container flex-column gap-12 p-16 full-width full-height overflow-scroll border-box">
          {vendorForm && (
            <div className="custom-form-detail-container px-16 py-12 flex-column gap-8">
              <input
                className="question-input p-12 xetgo-font-tag full-width border-box"
                value={formTitle}
                onChange={(e) => setFormTitle(e.target.value)}
                placeholder="Enter Title"
              />
              <textarea
                className={`answer-input description px-12 py-8 xetgo-font-tag full-width border-box disable-cursor`}
                value={formDescription}
                placeholder="Enter Description"
                onChange={(e) => setFormDescription(e.target.value)}
              ></textarea>
            </div>
          )}
          {allQuestions.length > 0 &&
            allQuestions.map((question, questionIndex) => (
              <CustomQuestion
                key={question.id}
                question={question}
                handleDeleteQuestion={handleDeleteQuestion}
                handleQuestionValueChanges={handleQuestionValueChanges}
                vendorForm={false}
                questionIndex={questionIndex}
              />
            ))}
          {allQuestions.length === 0 && (
            <div className="empty-state-main-container flex-column gap-48 full-height full-width align-items-center justify-content-center">
              <img
                height={243}
                width={235}
                src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250423101602-Group+%282%29.svg"
                alt="empty-icon"
              />
              <div className="text-containers flex-column gap-12 full-width ">
                <p style={{ color: "#333333" }} className="bold">
                  Your form is empty, No Fields Added Yet!
                </p>
                <p style={{ color: "#3333336B" }}>
                  {" "}
                  Start by clicking on the fields to add them to your form..
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomQuestionForm;
